import {Component, Input, OnInit} from "@angular/core";
import {ARTICLE_PATH, ENGLISH_TRANSLATION_ORIGIN, REPEAT} from '../../../../../../core/constants/article.constants';
import {DatePipe} from "@angular/common";
import * as jsdiff from "diff";
import {I18nSelectPipe} from "../../../../../../shared/pipes/i18nSelect.pipe";
import { TopicsService } from '../../../../../../core/services/topics/topics.service';
import { InstitutionsService } from '../../../../../../core/services/institutions/institutions.service';
import {JSONPatchOperation} from "../../../../../../core/models/articles/articles.model";

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.css'],
  standalone: false,
})
export class ChangelogComponent implements OnInit {
  @Input() diff!: JSONPatchOperation;

  constructor(
    private topicsService: TopicsService,
    private institutionsService: InstitutionsService,
    private i18nSelectPipe: I18nSelectPipe,
    private datePipe: DatePipe,
  ) {
    this.datePipe = new DatePipe($localize.locale === 'de' ? 'de-DE' : 'en-US');
  }

  path!: string;
  descriptionDiff?: string;
  displayValue?: string;
  displayBefore?: string;

  async ngOnInit() {
    // Convert Path
    const pathParts = this.diff.path.split('/').filter(part => part);
    this.path = pathParts
      .map((part, index) => {
        if (index === 0) {
          return ARTICLE_PATH[part] || part;
        } else {
          return isNaN(Number(part)) ? ARTICLE_PATH[part] || part : Number(part) + 1;
        }
      })
      .join(' ');


    // Convert Values
    if (this.diff.value != null && typeof this.diff.value === 'object') {
      this.displayValue = this.getObjectString(this.diff.value);
    }
    if (this.diff.before != null && typeof this.diff.before === 'object') {
      this.displayBefore = this.getObjectString(this.diff.before);
    }
    if (this.diff.path.includes('description') || this.diff.path.includes('englishDescription')){
      this.descriptionDiff = this.renderDiff(jsdiff.diffWords(this.diff.before, this.diff.value));
    }
    if (this.diff.path.includes('date') || this.diff.path.includes('validDate')) {
      this.displayBefore = this.datePipe.transform(this.diff.before) || this.diff.before
      this.displayValue = this.datePipe.transform(this.diff.value) || this.diff.value
    }
    if (this.diff.path.includes('topic') || this.diff.path.includes('subjectAreas')){
      const topicBefore = await this.topicsService.getOne(this.diff.before).toPromise()
      const topicAfter = await this.topicsService.getOne(this.diff.value).toPromise()
      this.displayBefore = this.i18nSelectPipe.transform(topicBefore,'name','englishName') || this.diff.before
      this.displayValue = this.i18nSelectPipe.transform(topicAfter,'name','englishName') || this.diff.value
    }
    if (this.diff.path.includes('institutionRestrictions')){
      const topicBefore = await this.institutionsService.getOne(this.diff.before).toPromise()
      const topicAfter = await this.institutionsService.getOne(this.diff.value).toPromise()
      this.displayBefore = topicBefore?.name || this.diff.before
      this.displayValue = topicAfter?.name || this.diff.value
    }
    if (typeof this.diff.before === 'boolean') {
      this.displayBefore = this.diff.before ? $localize`:@@changelog-true:Ja` : $localize`:@@changelog-false:Nein`
    }
    if (typeof this.diff.value === 'boolean') {
      this.displayValue = this.diff.value ? $localize`:@@changelog-true:Ja` : $localize`:@@changelog-false:Nein`
    }
    if (this.diff.path.includes('repeat')) {
      this.displayBefore = REPEAT.find(r => r.repeat === this.diff.before)?.name;
      this.displayValue = REPEAT.find(r => r.repeat === this.diff.value)?.name;
    }
    if (this.diff.path.endsWith('/englishTranslationOrigin')) {
      this.displayBefore = ENGLISH_TRANSLATION_ORIGIN.find(r => r.value === this.diff.before)?.name;
      this.displayValue = ENGLISH_TRANSLATION_ORIGIN.find(r => r.value === this.diff.value)?.name;
    }
  }

  getObjectString(obj: any) {
    return Object.entries(obj).map(([key, value]) => {
      if (key === 'date' && typeof value === 'string') {
        value = this.datePipe.transform(value) || value;
      }
      if (key === 'repeat') {
        value = REPEAT.find(r => r.repeat === value)?.name || this.diff.value;
      }
      return `${ARTICLE_PATH[key]}: ${value || '-'}`;
    }).join(' • ');
  }

  renderDiff(diff: jsdiff.Change[]) {
    return diff.map(part => {
      if (part.added) {
        return `<span class="diff-added">${part.value}</span>`;
      }else if (part.removed) {
        return `<s class="diff-removed">${part.value}</s>`;
      } else {
        return part.value;
      }
    }).join('');
  }

}
